module.exports = __webpack_public_path__ + "img/44.2.TN.071c57c2.png";